// 引入接口
import {
  SearchForumTypeInfoList,
  SearchPetTypeInfoList,
  SearchLeturerInfoList,
  SearchClassTypeInfoList,
  SearchHomeRecommendTypeInfoList,
  SearchBannerInfoList,
  SearchBannerWeightMsg,
  SearchBannerPositionList
} from "@/api/public.js";

const state = {
  // 论坛类型
  SearchForumTypeInfoList: {},
  // 宠物类型
  SearchPetTypeInfoList: {},
  // 讲师列表
  SearchLeturerInfoList: {},
  // 课程分类
  SearchClassTypeInfoList: {},
  // 课程首页推荐
  SearchHomeRecommendTypeInfoList: {},
  // 获取权重列表,
  SearchBannerInfoList: {},
  // 获取权重信息
  SearchBannerWeightMsg: {},
  // 获取banner位置
  SearchBannerPositionList: {}
};

const mutations = {
  SET_TYPELIST: (state, SearchForumTypeInfoList) => {
    state.SearchForumTypeInfoList = SearchForumTypeInfoList;
  },
  SET_PETTYPE: (state, SearchPetTypeInfoList) => {
    state.SearchPetTypeInfoList = SearchPetTypeInfoList;
  },
  SET_LETURER: (state, SearchLeturerInfoList) => {
    state.SearchLeturerInfoList = SearchLeturerInfoList;
  },
  SET_CLASSTYPEINFOLIST: (state, SearchClassTypeInfoList) => {
    state.SearchClassTypeInfoList = SearchClassTypeInfoList;
  },
  SET_HOMERECOMMEND: (state, SearchHomeRecommendTypeInfoList) => {
    state.SearchHomeRecommendTypeInfoList = SearchHomeRecommendTypeInfoList;
  },
  SET_BANNERMSG: (state, SearchBannerWeightMsg) => {
    state.SearchBannerWeightMsg = SearchBannerWeightMsg;
  },
  SET_BANNERPOSITION: (state, SearchBannerPositionList) => {
    state.SearchBannerPositionList = SearchBannerPositionList;
  }
};

const actions = {
  // 论坛类型
  getSearchForumTypeInfoList({ commit }, val) {
    return new Promise((resolve, reject) => {
      SearchForumTypeInfoList().then(res => {
        // console.log(res, "获取论坛类型列表");
        commit("SET_TYPELIST", res.Data);
        resolve(res.Data);
      });
    }).catch(error => {
      reject(error);
    });
  },
  // 获取宠物类型
  getSearchPetTypeInfoList({ commit }, val) {
    return new Promise((resolve, reject) => {
      SearchPetTypeInfoList().then(res => {
        // console.log(res, "查询宠物类型");
        commit("SET_PETTYPE", res.Data);
        resolve(res.Data);
      });
    }).catch(error => {
      reject(error);
    });
  },
  // 获取 讲师列表
  getSearchLeturerInfoList({ commit }, val) {
    return new Promise((resolve, reject) => {
      SearchLeturerInfoList().then(res => {
        // console.log(res, "查询讲师列表");
        commit("SET_LETURER", res.Data);
        resolve(res.Data);
      });
    }).catch(error => {
      reject(error);
    });
  },
  // 获取 课程分类
  getSearchClassTypeInfoList({ commit }, val) {
    return new Promise((resolve, reject) => {
      SearchClassTypeInfoList().then(res => {
        console.log(res, "查询 课程分类");
        commit("SET_CLASSTYPEINFOLIST", res.Data);
        resolve(res.Data);
      });
    }).catch(error => {
      reject(error);
    });
  },
  // 获取 课程首页推荐类型
  getSearchHomeRecommendTypeInfoList({ commit }, val) {
    return new Promise((resolve, reject) => {
      SearchHomeRecommendTypeInfoList().then(res => {
        // console.log(res, "查询 课程首页推荐类型");
        commit("SET_HOMERECOMMEND", res.Data);
        resolve(res.Data);
      });
    }).catch(error => {
      reject(error);
    });
  },
  // 获取 获取权重信息
  getSearchBannerWeightMsg({ commit }, val) {
    return new Promise((resolve, reject) => {
      SearchBannerWeightMsg({ ID: val }).then(res => {
        // console.log(res, "查询获取权重信息");
        commit("SET_BANNERMSG", res.Data);
        resolve(res.Data);
      });
    }).catch(error => {
      reject(error);
    });
  },
  // 查询Banner位置列表
  getSearchBannerPositionList({ commit }, val) {
    return new Promise((resolve, reject) => {
      SearchBannerPositionList().then(res => {
        // console.log(res, "查询 查询Banner位置列表");
        commit("SET_BANNERPOSITION", res.Data);
        resolve(res.Data);
      });
    }).catch(error => {
      reject(error);
    });
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};



// WEBPACK FOOTER //
// ./src/store/modules/PublicData.js